define('presentation/settings/blocking/viewModels/blockPhoneNumberViewModel',[
    'businessServices/router/router',
    'settings/navigationConfiguration',
    'common/promises/promiseFactory',
    'presentation/settings/blocking/facades/blockingFacade',
    'presentation/settings/blocking/validators/blockPhoneNumberValidator',
    'businessServices/state/modelStateObserver',
], function (
    /** @type typeof import('businessServices/router/router') */
    _router,
    /** @type typeof import('settings/navigationConfiguration') */
    _navigationConfiguration,
    /** @type typeof import('common/promises/promiseFactory') */
    PromiseFactoryConstructor,
    /** @type typeof import('presentation/settings/blocking/facades/blockingFacade') */
    BlockingFacade,
    /** @type typeof import('presentation/settings/blocking/validators/blockPhoneNumberValidator') */
    ValidatorConstructor,
    /** @type typeof import('businessServices/state/modelStateObserver') */
    ModelStateObserverConstructor
) {
    return function () {
        /** @typedef {import('presentation/settings/blocking/viewModels/blockPhoneNumberViewModel')} BlockPhoneNumberViewModel } */

        /** @type {BlockPhoneNumberViewModel}*/
        let self = this;

        /** @type {(typeof PromiseFactory)["prototype"]} */
        const _promiseFactory = new PromiseFactoryConstructor();
        const _facade = new BlockingFacade(_promiseFactory);

        self.blockPhoneNumber = ko.observable("").extend({observeState: true});
        self.countryAbbreviation = ko.observable("us");
        self.modelStateObserver = null;
        self.validator = null;

        const _returnToBlocking = () => {
            _router.navigate(_navigationConfiguration.routesById.blocking.url);
        };

        self.validate = () => self.validator.validate();

        self.cancelForm = () => {
            self.modelStateObserver.restoreData();
            _returnToBlocking();
        };

        self.savePage = () => {
            return _promiseFactory.deferWithMinimumWait((deferredObject) => {
                self.validator.validate()
                    .fail(deferredObject.reject)
                    .done((/** @type {boolean}*/isValid) => {
                        if (isValid === false) {
                            deferredObject.resolve(false);
                            return;
                        }

                        _facade.blockPhoneNumber(self.blockPhoneNumber())
                            .done(() => {
                                self.modelStateObserver.saveData();
                                deferredObject.resolve();
                                _returnToBlocking();
                            });
                    });
            });
        };

        self.activate = () => {
            return _initialize();
        };

        const _initialize = () => {
            self.modelStateObserver = new ModelStateObserverConstructor(self, true);
            self.modelStateObserver.commitData();

            self.validator = new ValidatorConstructor();
            self.validator.registerViewModel(self);

            return _promiseFactory.wait();
        };
    };
});

